export const VERIFICATION = '/verification';
